import styled from 'styled-components'

export const EmailContainer = styled.div`
  width: 340px;
`

export const DeletedEmailContainer = styled.div`
  width: 340px;
  flex-basis: 85%;
  color: #ed555a;
`

export const StatusContainer = styled.div`
  flex: 1;
`
